import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className", "hotkey"],
    _excluded2 = ["key"];
import { jsx } from 'react/jsx-runtime';
import { Viewport } from '@radix-ui/react-toast';
import clsx from 'clsx';
import { forwardRef, useEffect } from 'react';
import { useNotification } from './notification-provider.js';
import styles from './notification.module.js';
import { PrivateNotificationElement } from './private-notification-element.js';
var VIEWPORT_DEFAULT_HOTKEY = ['F8'];
/**
 * Renders container with Notifications.
 *
 * Based on Radix-UI [Viewport](https://www.radix-ui.com/docs/primitives/components/toast#viewport).
 */

var NotificationViewport = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  var className = props.className,
      _props$hotkey = props.hotkey,
      hotkey = _props$hotkey === void 0 ? VIEWPORT_DEFAULT_HOTKEY : _props$hotkey,
      rest = _objectWithoutProperties(props, _excluded);

  var _useNotification = useNotification(),
      notifications = _useNotification.notifications;

  useEffect(function () {
    var handleKeyDown = function handleKeyDown(event) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      var isHotkeyPressed = hotkey.every(function (key) {
        return event[key] || event.code === key;
      }); // check `isComposing` to fix issue with japanese input, see:
      // https://github.com/radix-ui/primitives/pull/2558

      if (isHotkeyPressed && event.isComposing) {
        event.stopPropagation();
      }
    };

    document.addEventListener('keydown', handleKeyDown, {
      capture: true,
      passive: true
    });
    return function () {
      return document.removeEventListener('keydown', handleKeyDown);
    };
  }, [hotkey]);
  return jsx(Viewport, _objectSpread(_objectSpread({}, rest), {}, {
    ref: forwardedRef,
    className: clsx(styles.viewport, className),
    hotkey: hotkey,
    children: Array.from(notifications.values()).map(function (_ref) {
      var key = _ref.key,
          notificationProps = _objectWithoutProperties(_ref, _excluded2);

      return jsx(PrivateNotificationElement, _objectSpread({}, notificationProps), key);
    })
  }));
});
export { NotificationViewport };